import React from 'react'
import { icons } from '../utilits/icons'
import { optionElips4 } from '../utilits/statisticTools'
import Chart from 'react-apexcharts'

export default function Tire() {
  return (
    <div className='range'>
      <span>{icons.tireWear}</span>
      <h3>Energy</h3>
      <Chart options={optionElips4.options} series={optionElips4.series} type="radialBar" />
    </div>
  )
}
